.progressContainer {
    width: 100%;
}
